"use client";

import { AuthProvider, VerticalProvider } from "@/contexts";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <VerticalProvider>{children}</VerticalProvider>
    </AuthProvider>
  );
}
